import { render } from "./price-type-form.vue?vue&type=template&id=4e4aca4f&ts=true"
import script from "./price-type-form.vue?vue&type=script&lang=ts"
export * from "./price-type-form.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__